import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { AccountId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { AllGroupsResponse, UserGroupsResponse } from './types.tsx';

// Get all groups (including ones user is not a member of)

const MAX_GROUPS = 5;

export const getAllGroupsPath = (): string => '/rest/api/2/groups/picker';

const getAllGroupsUrl = (query: string, maxResults: number = MAX_GROUPS): string =>
	`${getAllGroupsPath()}?maxResults=${maxResults}&query=${encodeURIComponent(query)}`;

export const getAllGroups = (
	query = '',
	maxResults: number = MAX_GROUPS,
): Promise<AllGroupsResponse> => fetchJson(getAllGroupsUrl(query, maxResults));

// Get only groups user is a member of
export const getUserGroupsPath = (): string => '/rest/api/3/user/groups';

const getUserGroupsUrl = (accountId: AccountId): string =>
	`${getUserGroupsPath()}?accountId=${accountId}`;

export const getUserGroups = (accountId: AccountId): Promise<UserGroupsResponse> =>
	fetchJson(getUserGroupsUrl(accountId));
